import * as React from 'react';

function AxisFullLogo(props) {
  return (
    <svg
      width={86}
      height={24}
      viewBox="0 0 86 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.898 0L0 .898 23.102 24l.898-.898L.898 0z"
        fill="url(#paint0_linear_7729_33178)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6 22.351L.45 23.503c1.24 1.24 7.338-2.848 13.622-9.132C20.355 8.088 24.444 1.99 23.203.75L22.052 1.9a4.674 4.674 0 01-.062.183c-.256.704-.783 1.68-1.586 2.878-1.595 2.378-4.129 5.41-7.23 8.512-3.102 3.101-6.134 5.636-8.512 7.23-1.198.803-2.175 1.33-2.879 1.586l-.105.037-.077.025z"
        fill="#F23C73"
      />
      <path
        d="M23.203.748c-1.24-1.24-7.339 2.849-13.622 9.132C3.297 16.163-.791 22.262.449 23.503l1.152-1.152c.017-.056.038-.117.062-.182.256-.705.783-1.681 1.586-2.88 1.594-2.377 4.128-5.41 7.23-8.51 3.102-3.102 6.134-5.637 8.512-7.231 1.198-.803 2.174-1.33 2.878-1.586a4.84 4.84 0 01.183-.062L23.203.748z"
        fill="url(#paint1_linear_7729_33178)"
      />
      <g clipPath="url(#clip0_7729_33178)" fill="#000">
        <path d="M51.718 6.21c.228 0 .342 0 .448.028a.826.826 0 01.26.123c.09.063.163.15.308.326l2.227 2.678c.342.411.513.617.718.694.18.067.379.07.56.006.208-.072.384-.273.735-.676l2.376-2.726c.145-.167.218-.25.305-.31a.827.827 0 01.255-.116c.104-.027.214-.027.436-.027h.497c.462 0 .692 0 .806.093.1.082.155.204.151.332-.004.148-.156.322-.458.67l-3.35 3.847c-.264.304-.397.456-.448.627a.824.824 0 00-.002.463c.048.172.179.326.44.633l3.424 4.037c.294.347.441.52.445.666a.413.413 0 01-.153.33c-.114.092-.341.092-.795.092h-.471c-.227 0-.34 0-.446-.028a.832.832 0 01-.26-.122c-.09-.063-.162-.15-.308-.324l-2.516-3.01c-.344-.412-.516-.618-.723-.694a.826.826 0 00-.562-.004c-.207.074-.382.278-.732.685l-2.605 3.036c-.146.17-.219.255-.307.315a.827.827 0 01-.257.119c-.104.027-.216.027-.44.027h-.505c-.457 0-.686 0-.8-.093a.413.413 0 01-.152-.33c.004-.147.153-.32.45-.668l3.606-4.202c.26-.303.39-.455.44-.626a.826.826 0 00.002-.46c-.049-.171-.178-.324-.438-.629l-3.133-3.694c-.294-.347-.441-.52-.444-.666a.413.413 0 01.152-.33c.114-.092.341-.092.796-.092h.468zM68.605 6.21c.19 0 .285 0 .364.015a.827.827 0 01.65.651c.017.08.017.174.017.364v9.73c0 .19 0 .285-.016.364a.827.827 0 01-.65.65c-.08.016-.175.016-.365.016s-.285 0-.364-.015a.827.827 0 01-.651-.651c-.016-.08-.016-.174-.016-.364V7.24c0-.19 0-.285.016-.364a.827.827 0 01.65-.65c.08-.016.175-.016.365-.016zM84.052 6.21c.19 0 .285 0 .364.015a.827.827 0 01.651.651c.015.08.015.174.015.364s0 .286-.015.365a.827.827 0 01-.65.65c-.08.016-.175.016-.365.016h-5.014c-.535 0-.925.134-1.17.402-.244.256-.367.588-.367.995 0 .175.024.35.07.524.058.163.152.315.28.454.14.129.32.233.541.315.222.07.507.105.856.105h2.76c.803 0 1.462.104 1.974.314.512.198.914.46 1.205.786.303.326.507.699.611 1.118.117.42.175.838.175 1.258 0 .5-.07.96-.21 1.38a2.88 2.88 0 01-.663 1.1c-.303.303-.693.541-1.17.716-.466.175-1.037.262-1.713.262H76.68c-.19 0-.285 0-.364-.015a.825.825 0 01-.65-.651c-.016-.08-.016-.174-.016-.364s0-.286.016-.365a.825.825 0 01.65-.65c.08-.016.174-.016.364-.016h5.608c.559 0 .966-.134 1.222-.402.268-.28.402-.634.402-1.065 0-.187-.03-.367-.087-.542a1.059 1.059 0 00-.297-.471c-.14-.14-.333-.25-.577-.332-.233-.082-.53-.123-.89-.123h-2.743c-.792 0-1.438-.098-1.939-.296-.5-.198-.896-.46-1.188-.787a2.9 2.9 0 01-.594-1.1 4.888 4.888 0 01-.156-1.223c0-.489.064-.937.192-1.344.14-.42.355-.78.646-1.083a3.008 3.008 0 011.153-.7c.466-.174 1.024-.261 1.677-.261h4.943zM34.403 17.163c-.119.302-.178.453-.279.564a.826.826 0 01-.323.22c-.14.053-.302.053-.627.053h-.4c-.325 0-.488 0-.592-.069a.413.413 0 01-.176-.259c-.026-.121.034-.273.154-.576l3.783-9.576c.22-.56.53-.95.925-1.17.408-.234.926-.35 1.555-.35.617 0 1.124.116 1.52.35.407.22.716.61.925 1.17l3.642 9.584c.115.301.172.451.145.572a.414.414 0 01-.177.256c-.103.068-.264.068-.585.068h-.417c-.33 0-.494 0-.636-.054a.826.826 0 01-.325-.225c-.1-.113-.159-.268-.275-.576l-3.258-8.63c-.105-.268-.297-.401-.577-.401-.28 0-.477.133-.593.401l-3.409 8.648z" />
        <path d="M41.99 13.144h-7.445v2.026h7.446v-2.026z" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7729_33178"
          x1={0.449096}
          y1={0.449097}
          x2={23.551}
          y2={23.551}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F23C73" stopOpacity={0} />
          <stop offset={0.223958} stopColor="#F23C73" />
          <stop offset={0.78125} stopColor="#F23C73" />
          <stop offset={1} stopColor="#F23C73" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7729_33178"
          x1={12.2317}
          y1={7.22902}
          x2={6.70887}
          y2={12.7519}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F23C73" />
          <stop offset={0.307292} stopColor="#F23C73" stopOpacity={0} />
          <stop offset={0.671875} stopColor="#F23C73" stopOpacity={0} />
          <stop offset={1} stopColor="#F23C73" />
        </linearGradient>
        <clipPath id="clip0_7729_33178">
          <path
            fill="#fff"
            transform="translate(32 6)"
            d="M0 0H53.9731V12H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AxisFullLogo;
